import { render, staticRenderFns } from "./ViewRegistration.vue?vue&type=template&id=1ac76bb4&scoped=true"
import script from "./ViewRegistration.vue?vue&type=script&lang=js"
export * from "./ViewRegistration.vue?vue&type=script&lang=js"
import style0 from "./ViewRegistration.vue?vue&type=style&index=0&id=1ac76bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac76bb4",
  null
  
)

export default component.exports